<template>
  <el-dialog
    v-model="dialogVisible"
    title="Настройка доступа к мессенджеру"
    width="500px"
    class="settings-modal settings-modal--compact"
    align-center
    :close-on-click-modal="false"
  >
    <el-select
      v-model="selectedUsers"
      multiple
      filterable
      placeholder="Выберите пользователей с доступом"
      style="width: 100%;">
      <el-option
        v-for="user in employees"
        :key="user.id"
        :label="user.name"
        :value="String(user.id)"
      />
    </el-select>
    <el-checkbox v-if="messenger?.type === 'telegram'" v-model="allowGroups" :disabled="saving">Принимать сообщения из групп</el-checkbox>
    <template #footer>
      <el-button @click="dialogVisible = false">Отмена</el-button>
      <el-button type="primary" @click="saveAccess" :loading="saving" :disabled="saving">Сохранить</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'MessengerRolesDialog',
  props: {
    modelValue: Boolean,
    messengerId: [String, Number]
  },
  emits: ['update:modelValue'],
  data() {
    return {
      selectedUsers: [],
      allowGroups: false,
      saving: false
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    },
    ...mapState('users', ['employees']),
    messenger() { return this.$store.state.messengers.messengers.find(item => String(item.id) === String(this.messengerId)) || null; },
    transferData() {
      return this.employees.map(user => ({
        key: String(user.id),
        label: user.name
      }));
    }
  },
  watch: {
    modelValue: { immediate: true, handler(open) { if (open) this.hydrateAccess(); } },
    messengerId() { if (this.modelValue) this.hydrateAccess(); }
  },
  methods: {
    hydrateAccess() {
      this.selectedUsers = (this.messenger?.allowed_user_ids || []).map(String);
      this.allowGroups = this.messenger?.allow_groups === true || this.messenger?.allow_groups === 1 || this.messenger?.allow_groups === '1';
    },
    ...mapActions('messengers', ['updateMessengerAccess']),
    async saveAccess() {
      if (this.saving) return;
      if (!this.selectedUsers.length) { this.$notify({ type: 'warning', message: 'Выберите хотя бы одного сотрудника' }); return; }
      this.saving = true;
      try {
        await this.updateMessengerAccess({
          messengerId: this.messengerId,
          allowed_user_ids: this.selectedUsers,
          ...(this.messenger?.type === 'telegram' ? { allow_groups: this.allowGroups ? 1 : 0 } : {})
        });
        this.$notify({ type: 'success', message: 'Настройки доступа сохранены' });
        this.dialogVisible = false;
      } catch (error) {
        this.$notify({ type: 'error', message: 'Ошибка при сохранении настроек' });
      } finally { this.saving = false; }
    }
  }
};
</script>

<style scoped>
</style>
